<template>
    <div class="chainGroupChartLine" id="myChainGroupChartLine" :style="{height:height, width: width}"></div>
</template>
<script>
// import { validatenull } from '@/tdcommon/validate'

export default {
  name: 'd2-container-echarts-chainGroup-line',
  data () {
    return {
      xAxisData: [],
      seriesTotalQuantity: [],
      seriesTotalWeight: [],
      seriesTotalVolume: [],
      seriesTotalAmount: [],
      seriesTotalProfit: []
    }
  },
  props: {
    height: {
      type: String,
      default: () => ''
    },
    width: {
      type: String,
      default: () => ''
    },
    lineData: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
  },
  methods: {
    initChart (title, quantity, weight, volume, totalAmount, profit, xAxisData, seriesTotalQuantity, seriesTotalWeight, seriesTotalVolume, seriesTotalAmount, seriesTotalProfit) {
      // 引入基本模板
      var echarts = require('echarts/lib/echarts')
      // 引入折线图组件
      require('echarts/lib/chart/line')
      // 引入提示框和title组件
      require('echarts/lib/component/tooltip')
      require('echarts/lib/component/title')

      // 清空上一次值
      this.xAxisData = []
      this.seriesTotalQuantity = []
      this.seriesTotalWeight = []
      this.seriesTotalVolume = []
      this.seriesTotalAmount = []
      this.seriesTotalProfit = []
      // 赋值
      this.xAxisData = xAxisData
      this.seriesTotalQuantity = seriesTotalQuantity
      this.seriesTotalWeight = seriesTotalWeight
      this.seriesTotalVolume = seriesTotalVolume
      this.seriesTotalAmount = seriesTotalAmount
      this.seriesTotalProfit = seriesTotalProfit

      let myChart = echarts.init(document.getElementById('myChainGroupChartLine'))
      var colors = ['#55A8FD', 'rgba(50, 197, 233, 1)', 'rgba(159, 230, 184, 1)']
      var options = {
        color: colors,
        title: { text: title },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          feature: {
            // dataView: { show: true, readOnly: true },
            // magicType: { show: true, type: ['line', 'bar'] },
            // restore: {show: true},
            // saveAsImage: { show: true }
          }
        },
        legend: {
          data: [quantity, weight, volume, totalAmount, profit],
          selected: {
            '总重量': false,
            '总体积': false,
            '总运费': false,
            '总毛利': false
          }
        },
        grid: {
          left: '1%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xAxisData,
          axisLine: {
            lineStyle: {
              color: '#969696'
            }
          },
          axisLabel: {
            // formatter: function (value) {
            //   return value.split('').join('\n')
            // }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#E8E8E9'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#969696'
            }
          }
        },
        series: [
          {
            name: quantity,
            type: 'line',
            zlevel: 2,
            // barWidth: '10%',
            barGap: '100%',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(85,168,253,0.2)'
              }, {
                offset: 1,
                color: 'rgba(85,168,253,0)'
              }])
            },
            data: this.seriesTotalQuantity
          },
          {
            name: weight,
            type: 'line',
            zlevel: 2,
            barGap: '100%',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(50, 197, 233,0.2)'
              }, {
                offset: 1,
                color: 'rgba(50, 197, 233,0)'
              }])
            },
            data: this.seriesTotalWeight
          },
          {
            name: volume,
            type: 'line',
            zlevel: 2,
            barGap: '100%',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(159, 230, 184,0.2)'
              }, {
                offset: 1,
                color: 'rgba(159, 230, 184,0)'
              }])
            },
            data: this.seriesTotalVolume
          },
          {
            name: totalAmount,
            type: 'line',
            zlevel: 2,
            barGap: '100%',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(50, 197, 233,0.2)'
              }, {
                offset: 1,
                color: 'rgba(50, 197, 233,0)'
              }])
            },
            data: this.seriesTotalAmount
          },
          {
            name: profit,
            type: 'line',
            zlevel: 2,
            barGap: '100%',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(159, 230, 184,0.2)'
              }, {
                offset: 1,
                color: 'rgba(159, 230, 184,0)'
              }])
            },
            data: this.seriesTotalProfit
          }]
      }
      myChart.setOption(options, true)

      myChart.on('legendselectchanged', function (obj) {
        var name = obj.name
        var selected = obj.selected
        if (name === '总件数') {
          selected.总重量 = false
          selected.总体积 = false
          selected.总运费 = false
          selected.总毛利 = false
        } else if (name === '总重量') {
          selected.总件数 = false
          selected.总体积 = false
          selected.总运费 = false
          selected.总毛利 = false
        } else if (name === '总体积') {
          selected.总件数 = false
          selected.总重量 = false
          selected.总运费 = false
          selected.总毛利 = false
        } else if (name === '总运费') {
          selected.总件数 = false
          selected.总重量 = false
          selected.总体积 = false
          selected.总毛利 = false
        } else if (name === '总毛利') {
          selected.总件数 = false
          selected.总重量 = false
          selected.总体积 = false
          selected.总运费 = false
        }
        options.legend.selected = selected
        myChart.setOption(options, true)
      })
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-echarts-chaingroup-line/index.vue"
}
</vue-filename-injector>
